export const FILTERS = {
  ALL: "all",
  WITH_ASSIGNMENTS: "with-assignments",
  WITHOUT_ASSIGNMENTS: "without-assignments",
  PRIMARY_CONTACT: "primary-contact",
  LOGIN_USERS: "login-users"
};
